import { render, staticRenderFns } from "./smallTable.vue?vue&type=template&id=65795443"
import script from "./smallTable.vue?vue&type=script&lang=js"
export * from "./smallTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports